module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "hide-default-footer": _vm.hideDefaultFooter,
      "header-props": _vm.headerProps,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      },
      "item-key": _vm.itemKey
    },
    on: {
      "click:row": _vm.atualizaSelecionado
    },
    scopedSlots: _vm._u([{
      key: "header.checkbox",
      fn: function(ref) {
        var header = ref.header;

        return [(_vm.selecionarTudo === true) ? _c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": _vm.todosSelecionados
          },
          on: {
            "change": _vm.selecionarTodos
          }
        }) : _vm._e()]
      }
    }, {
      key: "item.checkbox",
      fn: function(props) {
        return [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "input-value": _vm.checkboxes.includes(props.item[_vm.itemKey]),
            "readonly": ""
          }
        })]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0269217f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-checkbox-table.vue
// module id = 555
// module chunks = 0